import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingServiceFee,
    getServiceFeeById,
    saveOrUpdateServiceFee,
    deleteServiceFee,
    downloadTemplate
} from 'app/services/ServiceFeeService';

import { ServiceFee } from "app/common/Model/ServiceFee";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import { importServiceFeeExcel } from "app/services/ImportExcelService";

export default class ServiceFeeStore {
    listAllServiceFee = [];
    searchServiceFee = new SearchObject();
    pageServiceFee = null;
    selectedServiceFee = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteServiceFee = false;
    openFormUpLoadFile = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingServiceFee = () => {
        pagingServiceFee(this.searchServiceFee).then(({ data }) => {
            this.pageServiceFee = data;
        })
    }

    handleChangeFormSearch = (searchServiceFee) => {
        this.searchServiceFee = checkSearchObject(this.searchServiceFee, searchServiceFee);
        this.pagingServiceFee();
    }

    handleOpenFormCreateOrEdit = (serviceFeeId) => {
        if (Boolean(serviceFeeId)) {
            getServiceFeeById(serviceFeeId).then(({ data }) => {
                this.selectedServiceFee = new ServiceFee(data);
                this.openFormCreateOrEdit = true;
            }).catch(function (error) {
                toast.error("Lấy dữ liệu không thành công");
            });
        } else {
            this.selectedServiceFee = new ServiceFee();
            this.openFormCreateOrEdit = true;
        }
    }

    saveServiceFee = (serviceFee, { setSubmitting }) => {
        saveOrUpdateServiceFee({ ...new ServiceFee(serviceFee) }).then(() => {
            this.selectedServiceFee = null;
            toast.success("Lưu phí dịch vụ thành công!");
            this.pagingServiceFee();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Lưu phí dịch vụ thất bại!");
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteServiceFee = (serviceFee) => {
        this.selectedServiceFee = { id: serviceFee?.id };
        this.openConfirmDeleteServiceFee = true;
    }

    handleConfirmDeleteServiceFee = () => deleteServiceFee(this.selectedServiceFee?.id)
        .then(() => {
            if (this.searchServiceFee?.pageIndex > 1 && this.pageServiceFee?.content?.length === 1) {
                this.searchServiceFee.pageIndex -= 1;
            }
            toast.success("Xóa phí dịch vụ thành công!");
            this.pagingServiceFee();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error("Xóa phí dịch vụ thất bại");
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteServiceFee = false;
        this.openFormUpLoadFile = false;
    }

    resetStore = () => {
        this.searchServiceFee = new SearchObject();
        this.pageServiceFee = null;
        this.selectedServiceFee = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteServiceFee = false;
    }
    handleUpLoadFile = () => {
        this.openFormUpLoadFile = true
    }
    handleImportExcelServiceFee = (file) => {
        importServiceFeeExcel(file).then(({ data }) => {
            toast.success("Tải file thành công!")
            this.handleClosePopup();
            this.pagingServiceFee()
        }).catch((error) => {
            console.error(error);
            toast.error("Lấy dữ liệu có lỗi");
        })
    }
    handleDownloadTemplate = async () => {
        try {
            const res = await downloadTemplate();
            const url = window.URL.createObjectURL(res?.data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "MAU_NHAP_DANH_MUC_PHI_DICH_VU" + ".xlsx");
            document.body.appendChild(link);
            link.click();
        } catch (error) {
            console.log(error);
        }
    };
}